module.exports = __webpack_public_path__ + "img/IMG_0447.67361829.png";